import EmployeesRouter from "@/views/rrhh/views/employees/router/employees.router.js";
import PayrollRouter from "@/views/rrhh/views/payroll/router/payroll.router.js";
import ViaticRouter from "@/views/rrhh/views/viatic/router/viatic.router.js";
import ReportsRouter from "@/views/rrhh/views/reports/router/reports.router.js";

import RRHHMain from "@/views/rrhh/views/RRHHMain.vue";
import AumentoSueldoRouter from "@/views/rrhh/views/aumento-sueldo/router/aumento-sueldo.router.js";
import TrabajoAdicionalRouter from "@/views/rrhh/views/trabajo-adicional/router/trabajo-adicional.router.js";
const routes = [
  {
    path: "/rrhh",
    name: "rrhh",
    redirect: () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        let userSections = [];
        if (userData && Array.isArray(userData.arr_sections)) {
          userSections = userData.arr_sections.map(s => s.section_id);
        }
        if (userSections.includes(8)) return { name: "rrhh-employees" };
        if (userSections.includes(14) || userSections.includes(52)) return { name: "rrhh-payroll" };
        if (userSections.includes(26)) return { name: "rrhh-viatic" };
        if (userSections.includes(27)) return { name: "rrhh-reports" };
        if (userSections.includes(42)) return { name: "rrhh-aumento-sueldo" };
        if (userSections.includes(43)) return { name: "rrhh-trabajo-adicional" };
        return { name: "rrhh-employees" };
      } catch (e) {
        return { name: "rrhh-employees" };
      }
    },
    meta: { module: 9 },
    component: RRHHMain,
    children: [
      ...EmployeesRouter,
      ...PayrollRouter,
      ...ViaticRouter,
      ...ReportsRouter,
      ...AumentoSueldoRouter,
      ...TrabajoAdicionalRouter
    ],
  },
];

export default routes;
